import { render, staticRenderFns } from "./AuthorizationCreate.vue?vue&type=template&id=778985cc&scoped=true&"
import script from "./AuthorizationCreate.vue?vue&type=script&lang=js&"
export * from "./AuthorizationCreate.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationCreate.vue?vue&type=style&index=0&id=778985cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778985cc",
  null
  
)

export default component.exports